import { createSlice } from "@reduxjs/toolkit";
import { AddressState } from "./address.state";
import {
  getAddresses,
  getAddressById,
  createAddress,
  updateAddress,
  deleteAddress,
  setDefaultAddress,
  queryTaxNumber,
} from "./address.thunk";

const initialState: AddressState = {
  data: [],
  status: "idle",
  error: null,
  selectedAddress: null,
  selectedAddressStatus: "idle",
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  isSettingDefault: false,
  isQueryingTax: false,
};

const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    resetAddresses: (state: AddressState) => {
      state.data = [];
      state.status = "idle";
      state.error = null;
      state.selectedAddress = null;
      state.selectedAddressStatus = "idle";
      state.isCreating = false;
      state.isUpdating = false;
      state.isDeleting = false;
      state.isSettingDefault = false;
    },
    clearSelectedAddress: (state: AddressState) => {
      state.selectedAddress = null;
      state.selectedAddressStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAddresses.pending, (state: AddressState) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAddresses.fulfilled, (state: AddressState, action) => {
        state.status = "success";
        state.data = action.payload.data.items;
      })
      .addCase(getAddresses.rejected, (state: AddressState, action) => {
        state.status = "error";
        state.error = action.payload ?? "Adresler yüklenirken bir hata oluştu.";
      })
      .addCase(getAddressById.pending, (state: AddressState) => {
        state.selectedAddressStatus = "loading";
        state.error = null;
      })
      .addCase(getAddressById.fulfilled, (state: AddressState, action) => {
        state.selectedAddressStatus = "success";
        state.selectedAddress = action.payload.data;
      })
      .addCase(getAddressById.rejected, (state: AddressState, action) => {
        state.selectedAddressStatus = "error";
        state.error = action.payload ?? "Adres yüklenirken bir hata oluştu.";
      })
      .addCase(createAddress.pending, (state: AddressState) => {
        state.isCreating = true;
        state.error = null;
      })
      .addCase(createAddress.fulfilled, (state: AddressState) => {
        state.isCreating = false;
      })
      .addCase(createAddress.rejected, (state: AddressState, action) => {
        state.isCreating = false;
        state.error = action.payload ?? "Adres eklenirken bir hata oluştu.";
      })
      .addCase(updateAddress.pending, (state: AddressState) => {
        state.isUpdating = true;
        state.error = null;
      })
      .addCase(updateAddress.fulfilled, (state: AddressState) => {
        state.isUpdating = false;
      })
      .addCase(updateAddress.rejected, (state: AddressState, action) => {
        state.isUpdating = false;
        state.error = action.payload ?? "Adres güncellenirken bir hata oluştu.";
      })
      .addCase(deleteAddress.pending, (state: AddressState) => {
        state.isDeleting = true;
        state.error = null;
      })
      .addCase(deleteAddress.fulfilled, (state: AddressState, action) => {
        state.isDeleting = false;
        const deletedId = action.meta.arg;
        if (state.data) {
          state.data = state.data.filter((address) => address.id !== deletedId);
        }
      })
      .addCase(deleteAddress.rejected, (state: AddressState, action) => {
        state.isDeleting = false;
        state.error = action.payload ?? "Adres silinirken bir hata oluştu.";
      })
      .addCase(setDefaultAddress.pending, (state: AddressState) => {
        state.isSettingDefault = true;
        state.error = null;
      })
      .addCase(setDefaultAddress.fulfilled, (state: AddressState) => {
        state.isSettingDefault = false;
      })
      .addCase(setDefaultAddress.rejected, (state: AddressState, action) => {
        state.isSettingDefault = false;
        state.error = action.payload ?? "Varsayılan adres ayarlanırken bir hata oluştu.";
      })
      .addCase(queryTaxNumber.pending, (state: AddressState) => {
        state.isQueryingTax = true;
      })
      .addCase(queryTaxNumber.fulfilled, (state: AddressState) => {
        state.isQueryingTax = false;
      })
      .addCase(queryTaxNumber.rejected, (state: AddressState) => {
        state.isQueryingTax = false;
      });
  },
});

export const { resetAddresses, clearSelectedAddress } = addressSlice.actions;
export default addressSlice.reducer;